(function () {
    'use strict';

     angular
        .module('app.core')
        .constant('defaultHttpRequestTransform', defaultHttpRequestTransform);

    var isObject = angular.isObject,
        isUndefined = angular.isUndefined,
        isDate = angular.isDate,
        toString = Object.prototype.toString,
        disallowed = { '[object File]': 1, '[object Blob]': 1, '[object FormData]': 1 };

    function defaultHttpRequestTransform(data) {
        return isObject(data) && !(toString.call(data) in disallowed) ? toJson(data) : data;
    }

    function toJson(obj) {
        return isUndefined(obj) ? undefined : JSON.stringify(obj, toJsonReplacer);
    }

    function toJsonReplacer(key, value) {
        var obj = this[key];

        return typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$' ? undefined
            : value && value.window === value ? '$WINDOW'
            : value && window.document === value ? '$DOCUMENT'
            : value && value.$evalAsync && value.$watch ? '$SCOPE'
            : isDate(obj) && obj.toLocalISOString ? obj.toLocalISOString()
            : value;
    }
})();
